var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card',{staticClass:"mb-2",style:({
      'background-color': _vm.$vuetify.theme.dark
        ? 'rgba(0,0,0,0.97)'
        : 'rgba(255,255,255,0.99)'
    })},[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',[_vm._t("default")],2),_c('v-card-text',[_c('v-data-table',{attrs:{"items":_vm.medlemmer,"headers":_vm.headers,"hide-default-footer":"","disable-pagination":""}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }